import dayjs from 'dayjs';
import type { InitialGroupOrderComparatorParams } from 'ag-grid-community';
import type { BarkerEventListing } from '../../types';
import { getNestedProperty } from '../../utils/getNestedProperty';
import type { SortItem } from './Inventory.SortItem';

export const DEFAULT_INVENTORY_EVENT_SORT: SortItem[] = [{ key: 'event.localDateTime', name: 'Date', dir: 'asc', sortIndex: 0 }];

const getEventSortDate = (event: BarkerEventListing['event']) => dayjs(event.utcDateTime ?? event.localDateTime);

export const compareInventoryEventListings = (dataA: BarkerEventListing, dataB: BarkerEventListing, sort?: SortItem[] | null) => {
  const activeSort = sort?.filter((x) => x.dir !== null && x.dir !== undefined);
  const sortOptions = activeSort?.length ? activeSort : DEFAULT_INVENTORY_EVENT_SORT;

  for (const sortOption of sortOptions) {
    const aValue = getNestedProperty(dataA, sortOption.key);
    const bValue = getNestedProperty(dataB, sortOption.key);
    if (sortOption.key === 'event.localDateTime') {
      const dateA = getEventSortDate(dataA.event);
      const dateB = getEventSortDate(dataB.event);
      if (!dateA.isSame(dateB)) {
        return dateA[sortOption.dir === 'desc' ? 'isAfter' : 'isBefore'](dateB) ? -1 : 1;
      }
      return dataA.event.name.localeCompare(dataB.event.name) || dataA.event.tenantId.localeCompare(dataB.event.tenantId);
    }
    if (aValue !== bValue && typeof aValue === 'string' && typeof bValue === 'string') {
      if (sortOption.dir === 'asc') {
        return (aValue as string).localeCompare(bValue);
      }
      return (bValue as string).localeCompare(aValue);
    }
    if (aValue !== bValue && typeof aValue === 'number' && typeof bValue === 'number') {
      if (sortOption.dir === 'asc') {
        return aValue > bValue ? 1 : -1;
      }
      return aValue < bValue ? 1 : -1;
    }
  }

  return 0;
};

export const compareInventoryEventGroups = (params: InitialGroupOrderComparatorParams<BarkerEventListing>, sort?: SortItem[] | null) => {
  const dataA = params.nodeA.allLeafChildren?.[0]?.data;
  const dataB = params.nodeB.allLeafChildren?.[0]?.data;

  if (!dataA || !dataB) {
    return 0;
  }

  return compareInventoryEventListings(dataA, dataB, sort);
};
